import * as React from 'react';
import { FC } from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { StoreLocator as StoreLocatorRefresh } from './new-ui';
import StoreLocatorOldUI from './old-ui';

/**
 *
 * StoreLocator purpose
 *
 */
export const StoreLocator: FC = () => {
  const useLocatorRefreshUI = useFlag(LaunchDarklyFlag.ENABLE_LOCATOR_UI_REFRESH);
  return useLocatorRefreshUI ? <StoreLocatorRefresh /> : <StoreLocatorOldUI />;
};

export default StoreLocator;
